import { Component } from '@angular/core';
import { MealMemberBasicDetailsComponent } from '../../meal-plan/meal-member-basic-details/meal-member-basic-details.component';
import { MealPlanServiceV2 } from '../meal-plan-v2.service';
import { MealPlanService } from '../../meal-plan/meal-plan.service';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgClass, formatDate, NgFor } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDateRangeInput } from '@angular/material/datepicker';
import { MatLabel } from '@angular/material/form-field';
import { MatHint } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { ToastService } from '../../services/toast.service';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { SharedServiceService } from '../../services/shared-service.service';
import { PreferenceComponent } from '../../meal-plan/preference/preference.component';
import { NgIf } from '@angular/common';
import { Router } from "@angular/router";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

declare var $: any;

@Component({
  selector: 'view-edit-plan',
  standalone: true,
  imports: [NgxMaterialTimepickerModule, MatProgressSpinnerModule, NgIf, PreferenceComponent, MealMemberBasicDetailsComponent, FormsModule, NgClass, NgFor, MatDateRangeInput, MatDatepickerModule, MatFormFieldModule, MatLabel, MatHint, MatNativeDateModule, MatInputModule],
  templateUrl: './view-edit-plan.component.html',
  styleUrl: './view-edit-plan.component.css'
})

export class ViewEditPlanComponent {

  id: any;
  memberId: any;
  selectedMealIds: any = [];
  selectedRecipeIds: any = [];
  fromDate: any;
  toDate: any;
  mode: any = 1;
  memberMealId: any;
  isLoading: any = 2;
  userMessage: string = '';
  planDetails: any = [];
  mealPlanMeta: any = null;
  userId: any;
  chatResponse: any;
  error: any = 0;
  showHideChatBot: any = false;
  existingMealPlan: any;
  exisitngMealPlanName: any;
  newMealPlan: any;
  memMealDate: string = '';
  currentDate: any = '';
  minDate: any;
  maxDate: any;
  mealPlanName: any;
  fastingDate: any;
  fastingIndex: any;
  selectFastingId: any;
  fastingDay: any;
  fastingStartTime: any;
  fastingEndTime: any;
  editRecipeObj: any;
  flow: number = 0;
  toDelMealId: any;
  toDelRecipeId: any;
  toDelMealRecipeIds: any[] = [];
  toDelRecipeDay: any;
  toDelMealType: string = '';
  toDelMealTime: string = '';
  messages: { sender: string; text: string; id: number }[] = [];
  constructor(private mealServiceV2: MealPlanServiceV2, private mealService: MealPlanService, private route: ActivatedRoute, private router: Router,
    private toast: ToastService, private SharedService: SharedServiceService) { }

  ngOnInit(): void {
    this.memberId = this.route.snapshot.queryParamMap.get('memberId');
    this.id = this.route.snapshot.queryParamMap.get('id');
    this.fromDate = this.route.snapshot.queryParamMap.get('fromDate');
    this.toDate = this.route.snapshot.queryParamMap.get('toDate');
    this.mode = this.route.snapshot.queryParamMap.get('mode');
    this.memberMealId = this.route.snapshot.queryParamMap.get('memberMealId');
    var flow = this.route.snapshot.queryParamMap.get('flow');
    if (flow != null) {
      this.flow = parseInt(flow);
    }
    this.isLoading = 1;
    this.mealServiceV2.getMealPlanDetails(this.id, this.fromDate, this.toDate).subscribe(data => {
      this.isLoading = 2;
      if (data === 1) {
        this.error = 1;
        this.toast.errorMessage("Sorry, there was an error while processing your request. Please try again!");
      } else {
        this.error = 0;
        this.mealPlanMeta = data;
        this.mealPlanName = this.mealPlanMeta.mealPlanName;
        this.planDetails = this.mealPlanMeta.response;
        this.normalizePlanDetails();
      }
    });
    this.SharedService.checkLogin().subscribe({
      next: (isLoggedIn: boolean) => {
        let user = this.SharedService.getLoggedInUser();
        this.userId = user.id;
      },
      error: (error) => {
        this.toast.errorMessage("Some Error Occurred. Please try again!");
        console.error('Error occurred during login check:', error);
      }
    });

  }

  private normalizePlanDetails(): void {
    if (this.planDetails && Array.isArray(this.planDetails)) {
      this.planDetails.forEach((plan: any) => {
        if (!Array.isArray(plan.meals)) plan.meals = [];
        if (!Array.isArray(plan.fastings)) plan.fastings = [];
      });
    }
  }

  private getTimeStringSortValue(timeStr: string): number {
    if (!timeStr || typeof timeStr !== 'string') return 24 * 60;
    const normalized = String(timeStr).trim().replace(/\s+/g, ' ');
    const d = new Date('1970-01-01 ' + normalized);
    if (!isNaN(d.getTime())) return d.getHours() * 60 + d.getMinutes();
    const parts = normalized.split(':');
    if (parts.length >= 2) {
      const h = parseInt(parts[0], 10);
      const m = parseInt(parts[1], 10) || 0;
      if (!isNaN(h)) return h * 60 + m;
    }
    return 24 * 60;
  }

  /** Returns meals and fastings for a plan in chronological order by start time (mealTime / fromTime). */
  getTimelineItems(plan: any): { type: 'meal' | 'fasting'; meal?: any; fasting?: any }[] {
    if (!plan) return [];
    const items: { type: 'meal' | 'fasting'; meal?: any; fasting?: any; sortKey: number }[] = [];
    const meals = plan.meals && Array.isArray(plan.meals) ? plan.meals : [];
    const fastings = plan.fastings && Array.isArray(plan.fastings) ? plan.fastings : [];
    meals.forEach((m: any) => {
      items.push({ type: 'meal', meal: m, sortKey: this.getTimeStringSortValue(m?.mealTime ?? m?.mealtime) });
    });
    fastings.forEach((f: any) => {
      items.push({ type: 'fasting', fasting: f, sortKey: this.getTimeStringSortValue(f?.fromTime) });
    });
    items.sort((a, b) => a.sortKey - b.sortKey);
    return items.map(({ type, meal, fasting }) => (type === 'meal' ? { type, meal } : { type, fasting }));
  }

  changeImg(id: any) {
    var collapse = document.getElementById(id + 'col');
    collapse?.classList.toggle('collapse');
    var img = document.getElementById(id) as HTMLImageElement;
    if (img.src.includes('down1.png')) {
      img.src = 'assets/img/up2.png';
    } else {
      img.src = 'assets/img/down1.png';
    }
  }

  sendMessage() {
    if (this.userMessage.trim() === '') return;
    this.messages.push({ sender: 'user', text: this.userMessage.trim(), id: new Date().getTime() });
    let chatHistory = [];
    let startIndex = 0;
    if (this.messages.length > 1) {
      if (this.messages.length > 5) {
        startIndex = this.messages.length - 5;
      }
      for (let i = startIndex; i < this.messages.length; i++) {
        let msg = this.messages[i];
        if (msg.sender === 'assistant') {
          chatHistory.push({ role: 'assistant', content: msg.text });
        } else {
          chatHistory.push({ role: 'user', content: msg.text });
        }
      }
    }
    this.messages.push({ sender: 'assistant', text: 'Processing...', id: new Date().getTime() + 1 });
    this.scrollToBottom(100);
    let payload = {
      "user_message": this.userMessage.trim(),
      "plan_id": this.id,
      "userId": this.userId,
      "memberId": this.memberId,
      "chat_history": chatHistory,
      "selected_meal_ids": this.selectedMealIds,
      "selected_recipe_ids": this.selectedRecipeIds
    };
    this.mealServiceV2.sendMessage(payload).subscribe(response => {
      this.isLoading = 2;
      if (response === 1) {
        this.messages.pop();
        this.messages.push({
          sender: 'assistant',
          text: 'Sorry, there was an error while processing your request. Please try again!',
          id: new Date().getTime() + 1
        });
      } else {
        let resp: any = response;
        this.messages.pop();
        this.messages.push({ sender: 'assistant', text: resp.response_message, id: new Date().getTime() + 1 });
        if (resp.function_type === 'edit_meal_plan') {
          this.isLoading = 1;
          this.planDetails = [];
          this.mealServiceV2.getMealPlanDetails(this.id, this.fromDate, this.toDate).subscribe(data => {
            this.isLoading = 2;
            if (data === 1) {
              this.error = 1;
              this.toast.errorMessage("Sorry, there was an error while processing your request. Please try again!");
            } else {
              this.error = 0;
              this.planDetails = data;
              this.mealPlanName = this.planDetails.mealPlanName;
              this.planDetails = this.planDetails.response;
              this.selectedMealIds = [];
              this.selectedRecipeIds = [];
            }
          });
        }
      }
      this.scrollToBottom(200);
    });
    this.userMessage = '';
  }

  scrollToBottom(timeout: any) {
    setTimeout(() => {
      let id = this.messages[this.messages.length - 1];
      const chatContainer = document.getElementById(id?.id + "");
      chatContainer?.scrollIntoView();
    }, timeout);

  }

  // wrapper for Assign Meal Plan button on edit page
  assignOrWarnFromEdit() {
    $('#confirmAssignMealPlan').modal('show');
  }

  proceedAssignMealPlan() {
    $('#confirmAssignMealPlan').modal('hide');
    this.assignMealPlan();
  }

  closeConfirmAssignMealPlan() {
    $('#confirmAssignMealPlan').modal('hide');
  }
  openChatBot() {
    this.showHideChatBot = true
  }
  hideChatBot() {
    this.showHideChatBot = false;
  }
  backBtn() {
    this.router.navigate(['/v2/all-meals'], {
      queryParams: {
        memberId: this.memberId,
        isType: 4
      }
    });
  }

  proceedDelRecipe() {
    let mealId = this.toDelMealId;
    let recId = this.toDelRecipeId;
    let day = this.toDelRecipeDay;
    this.isLoading = 1;
    this.mealServiceV2.deleteRecipeFromMealPlan(mealId, recId, this.id, day).subscribe(response => {
      if (response == 1) {
        this.isLoading = 2;
        this.toast.errorMessage('Some Exception Occurred. Please try again!');
      } else {
        const res: any = response;
        if (res.result) {
          this.toDelMealId = null;
          this.toDelRecipeId = null;
          this.toDelRecipeDay = null;
          this.toast.successMessage('Recipe Deleted Successfully');
          $('#deleteRecipeModal').modal('hide');
          this.mealServiceV2.getMealPlanDetails(this.id, this.fromDate, this.toDate).subscribe(data => {
            this.isLoading = 2;
            if (data === 1) {
              this.error = 1;
              this.toast.errorMessage("Sorry, there was an error while processing your request. Please try again!");
            } else {
              this.error = 0;
              this.planDetails = data;
              this.mealPlanName = this.planDetails.mealPlanName;
              this.planDetails = this.planDetails.response;
            }
          });
        } else {
          this.isLoading = 2;
          this.toast.errorMessage('Recipe Deletion Failed. Please try again!');
        }
      }
    });
  }

  // -------- Delete entire meal from plan --------
  deleteMeal(plan: any, meal: any) {
    if (!meal || !plan) {
      return;
    }
    // Collect all recipeIds for this meal (backend expects array)
    const recipeIds = Array.isArray(meal.mealRecipe)
      ? meal.mealRecipe.map((r: any) => r.recipeId)
      : [];

    if (!recipeIds.length) {
      this.toast.errorMessage('No recipes found for this meal to delete.');
      return;
    }

    this.toDelMealId = meal.mealId;
    this.toDelMealRecipeIds = recipeIds;
    this.toDelRecipeDay = plan.day;
    this.toDelMealType = meal.mealType ?? meal.meal_type ?? '';
    this.toDelMealTime = meal.mealTime ?? meal.mealtime ?? '';
    $('#deleteMealModal').modal('show');
  }

  proceedDelMeal() {
    if (!this.toDelMealId || !this.toDelMealRecipeIds || !this.toDelMealRecipeIds.length) {
      return;
    }
    this.isLoading = 1;
    this.mealServiceV2
      .deleteMealFromPlan(this.id, this.toDelMealId, this.toDelMealRecipeIds, this.toDelRecipeDay)
      .subscribe((response) => {
        if (response == 1) {
          this.isLoading = 2;
          this.toast.errorMessage('Some Exception Occurred. Please try again!');
        } else {
          const res: any = response;
          if (res.success) {
            this.toDelMealId = null;
            this.toDelMealRecipeIds = [];
            this.toDelRecipeDay = null;
            this.toDelMealType = '';
            this.toDelMealTime = '';
            this.toast.successMessage(res.message || 'Meal Deleted Successfully');
            $('#deleteMealModal').modal('hide');
            this.mealServiceV2.getMealPlanDetails(this.id, this.fromDate, this.toDate).subscribe(data => {
              this.isLoading = 2;
              if (data === 1) {
                this.error = 1;
                this.toast.errorMessage("Sorry, there was an error while processing your request. Please try again!");
              } else {
                this.error = 0;
                this.planDetails = data;
                this.mealPlanName = this.planDetails.mealPlanName;
                this.planDetails = this.planDetails.response;
              }
            });
          } else {
            this.isLoading = 2;
            this.toast.errorMessage('Meal Deletion Failed. Please try again!');
          }
        }
      });
  }

  closeDelMeal() {
    $('#deleteMealModal').modal('hide');
    this.toDelMealId = null;
    this.toDelMealRecipeIds = [];
    this.toDelRecipeDay = null;
    this.toDelMealType = '';
    this.toDelMealTime = '';
  }

  closeDelRecipe() {
    $('#deleteRecipeModal').modal('hide');
    this.toDelMealId = null;
    this.toDelRecipeId = null;
    this.toDelRecipeDay = null;
  }

  // A meal's card list combines its one primary "mealRecipe" with any
  // alternative "recipeOptions" - both render through the same recipe card
  // template and edit modal.
  getAllMealRecipeCards(meal: any): any[] {
    const mealRecipes = Array.isArray(meal?.mealRecipe) ? meal.mealRecipe : [];
    const options = Array.isArray(meal?.recipeOptions) ? meal.recipeOptions : [];
    return [...mealRecipes, ...options];
  }

  deleteRecipe(mealId: any, recId: any, day: any) {
    const dayPlan = this.planDetails.find((plan: any) => plan.day === day);
    const meal = dayPlan.meals?.find((m: any) => m.mealId === mealId);
    // The "must keep at least one" rule only applies to the meal's primary
    // recipe(s) - a recipeOptions entry is just an alternative and can always
    // be removed freely.
    const isPrimaryRecipe = Array.isArray(meal.mealRecipe) && meal.mealRecipe.some((r: any) => r.recipeId === recId);
    if (isPrimaryRecipe && (!meal.mealRecipe || meal.mealRecipe.length < 2)) {
      this.toast.errorMessage('Cannot delete the only recipe present in particular type!');
      return;
    }
    this.toDelMealId = mealId;
    this.toDelRecipeId = recId;
    this.toDelRecipeDay = day;
    $('#deleteRecipeModal').modal('show');
  }

  selectImg(mealId: any, recId: any, checked: boolean, type: any) {
    const mealKey = String(mealId);
    const recKey = String(recId);

    if (checked) {
      if (type === 'fasting') {
        if (!this.selectedMealIds.includes(mealKey)) {
          this.selectedMealIds.push(mealKey);
        }
      } else {
        if (!this.selectedMealIds.includes(mealKey)) {
          this.selectedMealIds.push(mealKey);
        }
        if (!this.selectedRecipeIds.includes(recKey)) {
          this.selectedRecipeIds.push(recKey);
        }
      }
    } else {
      if (type === 'fasting') {
        this.selectedMealIds = this.selectedMealIds.filter((item: any) => item !== mealKey);
      } else {
        // Only remove this recipe; do not remove mealId so other recipes in same meal stay selected
        this.selectedRecipeIds = this.selectedRecipeIds.filter((item: any) => item !== recKey);
      }
    }
  }

  isRecipeSelected(mealId: any, recId: any): boolean {
    const mealKey = String(mealId);
    const recKey = String(recId);
    return this.selectedMealIds.includes(mealKey) && this.selectedRecipeIds.includes(recKey);
  }
  convertSecondsToHoursAndMinutes(seconds: any) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    if (hours == 0) {
      return minutes + " mins";
    }
    return hours + " hr(s)" + " " + minutes + " min(s)";
  }

  assignMealPlan() {
    this.mealService.checkIsPlanAssign(this.memberId, this.fromDate, this.toDate).subscribe((response: any) => {
      let isExistPlan: any;
      isExistPlan = response;
      if (isExistPlan.isExist == true) {
        this.newMealPlan = { id: this.id, fromDate: this.fromDate, toDate: this.toDate, mealPlanName: this.mealPlanName };
        this.existingMealPlan = isExistPlan.mealPlan;
        this.exisitngMealPlanName = isExistPlan.mealPlanName;
        let fromDate = this.existingMealPlan.fromDate.split('T')[0];
        this.minDate = new Date(fromDate.split('-')[0], fromDate.split('-')[1] - 1, fromDate.split('-')[2]);
        let toDate = this.existingMealPlan.toDate.split('T')[0];
        this.maxDate = new Date(toDate.split('-')[0], toDate.split('-')[1] - 1, toDate.split('-')[2]);
        this.memMealDate = '';
        this.currentDate = '';
        $('#confirmAssign').modal('show');
      } else {
        let payload = {
          newObjectId: this.memberMealId,
          reqType: 'fromDraft'
        };
        this.mealServiceV2.updateMemberMealPlan(payload).subscribe((response: any) => {
          this.toast.successMessage('Meal Plan Assigned Successfully');
          this.router.navigate(['/v2/all-meals'], {
            queryParams: {
              memberId: this.memberId,
              isType: 4
            }
          });
        });
      }
    });
  }
  showcheckAssign() {
    $('#confirmAssign').modal('hide');
    $('#checkAssign').modal('show');
  }
  closeConfirmAssign() {
    $('#confirmAssign').modal('hide');
    this.router.navigate(['/v2/all-meals'], {
      queryParams: {
        memberId: this.memberId,
        isType: 4
      }
    });
  }

  setMemMealDate(date: HTMLInputElement) {
    var d = formatDate(date.value, 'yyyy-MM-dd', 'en-US');
    this.memMealDate = '';
    if (new Date(this.currentDate) < this.minDate) {
      this.toast.errorMessage('End date must be greater than from date.');
      return;
    }
    if (new Date(this.currentDate) > this.maxDate) {
      this.toast.errorMessage('End date must be less than to date.');
      return
    }
    let fromDate = this.newMealPlan.fromDate.split('T')[0];
    let newMealFromDate = new Date(fromDate.split('-')[0], fromDate.split('-')[1] - 1, fromDate.split('-')[2]);
    if (new Date(this.currentDate) >= newMealFromDate) {
      this.toast.errorMessage('End date must be less than new meal plan start date.');
      return;
    }
    this.memMealDate = d;
  }

  updateAndAssign() {
    if (this.memMealDate == '') {
      this.toast.errorMessage('Please select the end date.');
      return;
    }
    let payload = {
      currentObjectId: this.existingMealPlan.id,
      newObjectId: this.memberMealId,
      date: this.memMealDate,
      reqType: 'fromDraft'
    };
    this.mealServiceV2.updateMemberMealPlan(payload).subscribe(response => {
      if (response == 1) {
        this.toast.errorMessage('Some Exception Occurred. Please try again!');
      } else {
        this.toast.successMessage('Meal Plan Assigned Successfully');
        $('#checkAssign').modal('hide');
        this.router.navigate(['/v2/all-meals'], {
          queryParams: {
            memberId: this.memberId,
            isType: 4
          }
        });
      }
    });
  }

  openFastingModal(index: any, date: any, day: any, fastData: any) {
    this.fastingStartTime = '';
    this.fastingIndex = index;
    this.fastingEndTime = '';
    this.selectFastingId = '';
    if (fastData && fastData != null) {
      let d = new Date('01/01/1992 ' + fastData.fromTime);
      let hrs = d.getHours();
      let mins = d.getMinutes();
      this.fastingStartTime = (hrs < 10 ? '0' + hrs : hrs) + ':' + (mins < 10 ? '0' + mins : mins);
      d = new Date('01/01/1992 ' + fastData.toTime);
      hrs = d.getHours();
      mins = d.getMinutes();
      this.fastingEndTime = (hrs < 10 ? '0' + hrs : hrs) + ':' + (mins < 10 ? '0' + mins : mins);
      this.selectFastingId = fastData.id;
    }
    this.fastingDate = date;
    this.fastingDay = day;
    $('#fastingModal').modal('show');
  }

  saveFastingWindow() {
    if (this.fastingStartTime == '' || this.fastingEndTime == '') {
      this.toast.errorMessage('Please select fasting start/end time.');
      return;
    }
    var timeStart = new Date('01/01/1992 ' + this.fastingStartTime);
    var timeEnd = new Date('01/01/1992 ' + this.fastingEndTime);
    if (timeEnd <= timeStart) {
      this.toast.errorMessage('End time should be greater than start time.');
      return;
    }
    let meal = this.planDetails[this.fastingIndex];
    if (this.isFastingExists(meal.fastings, timeStart, timeEnd)) {
      this.toast.errorMessage('Fasting already added for this time.');
      return;
    }
    if (this.isRecipeExists(meal.meals, timeStart, timeEnd)) {
      this.toast.errorMessage('Recipe already there for this time.');
      return;
    }

    let payload = {
      mealPlanId: this.id,
      userId: this.userId,
      day: this.fastingDay,
      date: this.fastingDate,
      mealId: this.selectFastingId,
      fastingDetails: {
        fromTime: timeStart.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }),
        toTime: timeEnd.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
      }
    };

    this.isLoading = 1;
    this.mealServiceV2.addFasting(payload).subscribe(response => {
      if (response == 1) {
        this.isLoading = 2;
        this.toast.errorMessage('Some Exception Occurred. Please try again!');
      } else {
        this.toast.successMessage('Fasting Window Added/Updated Successfully');
        $('#fastingModal').modal('hide');
        this.mealServiceV2.getMealPlanDetails(this.id, this.fromDate, this.toDate).subscribe(data => {
          if (data === 1) {
            this.isLoading = 2;
            this.error = 1;
            this.toast.errorMessage("Sorry, there was an error while processing your request. Please try again!");
          } else {
            this.isLoading = 2;
            this.error = 0;
            this.planDetails = data;
            this.mealPlanName = this.planDetails.mealPlanName;
            this.planDetails = this.planDetails.response;
          }
        });
      }
      this.selectedMealIds = [];
      this.selectedRecipeIds = [];
    });
  }

  isRecipeExists(mealRecipe: any, newStartTime: Date, newEndTime: Date) {
    if (mealRecipe && mealRecipe.length > 0) {
      for (let i = 0; i < mealRecipe.length; i++) {
        let recipe = mealRecipe[i];
        let recipeTime = new Date('01/01/1992 ' + recipe.mealTime);
        if (recipeTime.getTime() == newStartTime.getTime() || recipeTime.getTime() == newEndTime.getTime()) {
          return true;
        }
        if (recipeTime < newEndTime && recipeTime > newStartTime) {
          return true;
        }
      }
    }
    return false;
  }

  isFastingExists(fastings: any, newStartTime: any, newEndTime: any) {
    if (fastings && fastings.length > 0) {
      for (let i = 0; i < fastings.length; i++) {
        let fasting = fastings[i];
        let fastingStart = new Date('01/01/1992 ' + fasting.fromTime);
        let fastingEnd = new Date('01/01/1992 ' + fasting.toTime);
        if (this.selectFastingId != fasting.id && ((fastingStart.getTime() == newStartTime.getTime() && fastingEnd.getTime() == newEndTime.getTime()) ||
          (fastingStart < newEndTime && fastingEnd > newStartTime))) {
          return true;
        }
      }
    }
    return false;
  }

  viewEditRecipe = (plan: any, meal: any, recipe: any) => {
    this.editRecipeObj = {
      recipeId: recipe.recipeId,
      mealId: meal.mealId,
      mealPlanId: this.id,
      date: plan.date,
      day: plan.day,
      userId: this.userId,
      recipeType: recipe.recipeType,
      recipeName: recipe.recipeName,
      isUpf: recipe.isUpf ?? false,
      isBev: recipe.isBev ?? false,
      isAlcoholic: recipe.isAlcoholic ?? false,
      nutrition: {
        // Calories are never taken from the API directly - always derived from
        // protein/carbs/fat/alcohol via the same formula used everywhere else.
        calories: this.computeCalories(recipe.nutrition.protein, recipe.nutrition.carbs, recipe.nutrition.fat, recipe.nutrition.alcoholGrams),
        protein: this.round2(recipe.nutrition.protein),
        carbs: this.round2(recipe.nutrition.carbs),
        fats: this.round2(recipe.nutrition.fat),
        fiber: this.round2(recipe.nutrition.fiber),
        sugar: this.round2(recipe.nutrition.sugar),
        alcoholGrams: this.round2(recipe.nutrition.alcoholGrams),
        alcoholAbv: this.round2(recipe.nutrition.alcoholAbv),
        caffeine: this.round2(recipe.nutrition.caffeine)
      }, ingredients: [], stores: [], brand: {
        brandName: '',
        barCode: '',
      },
      cookingMethods: [], restaurant: {
        name: '',
        location: '',
        website: '',
        phoneNumber: '',
      }
    };
    let recipeData = recipe.diyRecipeData;
    if (recipe.recipeType == 'Restaurant') {
      recipeData = recipe.restaurantRecipeData;
    } else if (recipe.recipeType == 'Packaged') {
      recipeData = recipe.packagedRecipeData;
    }

    if (recipeData.ingredients && recipeData.ingredients.length > 0) {
      for (let i = 0; i < recipeData.ingredients.length; i++) {
        const ingrType = recipeData.ingredients[i].type ?? null;
        const ingrServings = recipeData.ingredients[i].servings ?? null;
        const rawIngrNutrition = recipeData.ingredients[i].nutrition;
        // Always build a nutrition object (never null) so every nutrition field
        // renders as an empty, fillable input even when the API sent nothing.
        const ingrNutrition = {
          // Same rule as the recipe-level nutrition: calories are derived, not
          // taken from the API's own calories value.
          calories: rawIngrNutrition ? this.computeCalories(rawIngrNutrition.protein, rawIngrNutrition.carbs, rawIngrNutrition.fat, rawIngrNutrition.alcoholGrams) : null,
          protein: this.round2(rawIngrNutrition?.protein ?? null),
          carbs: this.round2(rawIngrNutrition?.carbs ?? null),
          fat: this.round2(rawIngrNutrition?.fat ?? null),
          fiber: this.round2(rawIngrNutrition?.fiber ?? null),
          sugar: this.round2(rawIngrNutrition?.sugar ?? null),
          alcoholGrams: this.round2(rawIngrNutrition?.alcoholGrams ?? null),
          alcoholAbv: this.round2(rawIngrNutrition?.alcoholAbv ?? null),
          caffeine: this.round2(rawIngrNutrition?.caffeine ?? null)
        };
        this.editRecipeObj.ingredients.push({
          name: recipeData.ingredients[i].ingredientName,
          quantity: recipeData.ingredients[i].measurement.quantity,
          unit: recipeData.ingredients[i].measurement.unit,
          type: ingrType,
          servings: ingrServings,
          nutrition: ingrNutrition,
          isUpf: recipeData.ingredients[i].isUpf ?? false,
          isBev: recipeData.ingredients[i].isBev ?? false,
          isAlcoholic: recipeData.ingredients[i].isAlcoholic ?? false
        });
      }
    }
    if (recipe.recipeType == 'DIY' || recipe.recipeType == 'FreshProduce') {
      if (recipe.diyRecipeData.instructions && recipe.diyRecipeData.instructions.length > 0) {
        for (let i = 0; i < recipe.diyRecipeData.instructions.length; i++) {
          this.editRecipeObj.cookingMethods.push({ method: recipe.diyRecipeData.instructions[i] });
        }
      }
    }
    if (recipe.recipeType == 'Packaged') {
      recipe.packagedRecipeData.stores.forEach((store: any) => {
        this.editRecipeObj.stores.push({ storeName: store.storeName, location: store.location, website: store.website });
      }
      );
      if (recipe.packagedRecipeData.brand != null) {
        this.editRecipeObj.brand.brandName = recipe.packagedRecipeData.brand;
        this.editRecipeObj.brand.barCode = recipe.packagedRecipeData.barcode;
      }
    } if (recipe.recipeType == 'Restaurant') {
      this.editRecipeObj.restaurant.name = recipe.restaurantRecipeData.restaurantName;
      this.editRecipeObj.restaurant.location = recipe.restaurantRecipeData.location;
      this.editRecipeObj.restaurant.website = recipe.restaurantRecipeData.website;
      this.editRecipeObj.restaurant.phoneNumber = recipe.restaurantRecipeData.phoneNumber;
    }
    $('#editModal').modal('show');
  }

  closeEditModal() {
    $('#editModal').modal('hide');
  }

  updateRecipe() {
    console.log(this.editRecipeObj);
    if (!this.isValidToProceed()) {
      return;
    }
    let cookingMethods = [];
    if ((this.editRecipeObj.recipeType == 'DIY' || this.editRecipeObj.recipeType == 'FreshProduce')
      && this.editRecipeObj.cookingMethods.length > 0) {
      for (let i = 0; i < this.editRecipeObj.cookingMethods.length; i++) {
        cookingMethods.push(this.editRecipeObj.cookingMethods[i].method);
      }
      this.editRecipeObj.recipeType = 'DIY';
      this.editRecipeObj.cookingMethods = cookingMethods;
    }
    this.isLoading = 1;
    const updatePayload = {
      ...this.editRecipeObj,
      nutrition: this.stripNullFields(this.editRecipeObj.nutrition),
      ingredients: this.editRecipeObj.ingredients.map((ingr: any) => {
        const { visible, ...ingrWithoutVisible } = ingr;
        const cleanIngr = this.stripNullFields(ingrWithoutVisible);
        if (cleanIngr.nutrition) {
          cleanIngr.nutrition = this.stripNullFields(cleanIngr.nutrition);
        }
        return cleanIngr;
      })
    };
    this.mealServiceV2.updateRecipe(updatePayload).subscribe(response => {
      if (response == 1) {
        this.toast.errorMessage('Some Exception Occurred. Please try again!');
        this.isLoading = 2;
      } else {
        this.toast.successMessage('Recipe Updated Successfully');
        $('#editModal').modal('hide');
        this.mealServiceV2.getMealPlanDetails(this.id, this.fromDate, this.toDate).subscribe(data => {
          this.isLoading = 2;
          if (data == 1) {
            this.error = 1;
            this.toast.errorMessage("Sorry, there was an error while processing your request. Please try again!");
          } else {
            this.error = 0;
            this.planDetails = data;
            this.mealPlanName = this.planDetails.mealPlanName;
            this.planDetails = this.planDetails.response;

          }
        });
      }
      this.selectedMealIds = [];
      this.selectedRecipeIds = [];
    });
  }

  isValidToProceed() {
    if (this.editRecipeObj.recipeName == null || this.editRecipeObj.recipeName.trim() == '') {
      this.toast.errorMessage('Please enter recipe name!');
      return false;
    }
    if (this.editRecipeObj.nutrition.calories == null || this.editRecipeObj.nutrition.protein == null
      || this.editRecipeObj.nutrition.carbs == null || this.editRecipeObj.nutrition.fats == null) {
      this.toast.errorMessage('Please enter nutrition values!');
      return false
    }
    if (this.editRecipeObj.ingredients.length == 0) {
      this.toast.errorMessage('Please add ingredients!');
      return false;
    }
    if (this.editRecipeObj.ingredients.length > 0) {
      for (let i = 0; i < this.editRecipeObj.ingredients.length; i++) {
        if (this.editRecipeObj.ingredients[i].name == null || this.editRecipeObj.ingredients[i].name.trim() == ''
          || this.editRecipeObj.ingredients[i].quantity <= 0 || this.editRecipeObj.ingredients[i].unit == null ||
          this.editRecipeObj.ingredients[i].unit.trim() == '') {
          this.toast.errorMessage('Please enter all/valid ingredient details!');
          return false;
        }
        if (this.editRecipeObj.ingredients[i].unit.match(/\d+/g)) {
          this.toast.errorMessage('Ingredients unit must be grams, ml, cup etc!');
          return false;
        }
      }
    }
    if (this.editRecipeObj.recipeType == 'DIY' || this.editRecipeObj.recipeType == 'FreshProduce') {
      if (this.editRecipeObj.cookingMethods.length == 0) {
        this.toast.errorMessage('Please add cooking methods!');
        return false;
      }
      if (this.editRecipeObj.cookingMethods.length > 0) {
        for (let i = 0; i < this.editRecipeObj.cookingMethods.length; i++) {
          if (this.editRecipeObj.cookingMethods[i].method == null || this.editRecipeObj.cookingMethods[i].method.trim() == '') {
            this.toast.errorMessage('Please enter all cooking methods!');
            return false;
          }
        }
      }
    }
    if (this.editRecipeObj.recipeType == 'Restaurant') {
      if (this.editRecipeObj.restaurant.name == null || this.editRecipeObj.restaurant.name.trim() == '' ||
        this.editRecipeObj.restaurant.location == null || this.editRecipeObj.restaurant.location.trim() == '') {
        this.toast.errorMessage('Please enter restaurant details!');
        return false;
      }
      if (this.editRecipeObj.restaurant.phoneNumber != null && this.editRecipeObj.restaurant.phoneNumber.trim() != ''
        && !/^(?:(?:\+91|91)[\s\-]?)?[789]\d{9}$|^(?:\+1[\s\-]?)?(\(?\d{3}\)?[\s\-]?)?\d{3}[\s\-]?\d{4}$/.test(this.editRecipeObj.restaurant.phoneNumber)) {
        this.toast.errorMessage('Please enter valid phone number!');
        return false;
      }
    }
    if (this.editRecipeObj.recipeType == 'Packaged') {
      if (this.editRecipeObj.brand.brandName == null || this.editRecipeObj.brand.brandName.trim() == '') {
        this.toast.errorMessage('Please enter brand details!');
        return false;
      }
      if (this.editRecipeObj.stores.length == 0) {
        this.toast.errorMessage('Please add stores!');
        return false;
      }
      if (this.editRecipeObj.stores.length > 0) {
        for (let i = 0; i < this.editRecipeObj.stores.length; i++) {
          if (this.editRecipeObj.stores[i].storeName == null || this.editRecipeObj.stores[i].storeName.trim() == ''
            || this.editRecipeObj.stores[i].location == null || this.editRecipeObj.stores[i].location.trim() == '') {
            this.toast.errorMessage('Please enter all store details!');
            return false;
          }
        }
      }
    }
    return true;
  }

  stripNullFields(obj: any): any {
    const result: any = {};
    Object.keys(obj || {}).forEach(key => {
      if (obj[key] !== null && obj[key] !== undefined) {
        result[key] = obj[key];
      }
    });
    return result;
  }

  deleteIngr(index: any) {
    this.editRecipeObj.ingredients.splice
      (index, 1);
    this.recalculateRecipeNutrition();
  }
  addIngr() {
    const nutrition = {
      calories: 0,
      protein: 0,
      carbs: 0,
      fat: 0,
      fiber: 0,
      sugar: 0,
      alcoholGrams: 0,
      alcoholAbv: 0,
      caffeine: 0
    };
    this.editRecipeObj.ingredients.push({
      name: '',
      quantity: 0,
      unit: 'grams',
      type: 'DIY',
      servings: 1,
      nutrition,
      isUpf: false,
      isBev: false,
      isAlcoholic: false
    });
    this.recalculateRecipeNutrition();
  }

  recalculateRecipeNutrition() {
    // recipe-level nutrition key -> ingredient nutrition key
    const fieldMap: { [key: string]: string } = {
      calories: 'calories',
      protein: 'protein',
      carbs: 'carbs',
      fats: 'fat',
      fiber: 'fiber',
      sugar: 'sugar',
      alcoholGrams: 'alcoholGrams',
      alcoholAbv: 'alcoholAbv',
      caffeine: 'caffeine'
    };
    const totals: any = {};
    Object.keys(fieldMap).forEach(recipeKey => {
      totals[recipeKey] = 0;
    });

    (this.editRecipeObj.ingredients || []).forEach((ingr: any) => {
      if (!ingr.nutrition) {
        return;
      }
      Object.keys(fieldMap).forEach(recipeKey => {
        const value = ingr.nutrition[fieldMap[recipeKey]];
        if (value !== null && value !== undefined && value !== '') {
          totals[recipeKey] += Number(value) || 0;
        }
      });
    });

    Object.keys(fieldMap).forEach(recipeKey => {
      // The stored value is always the numeric sum (never null) so a number
      // input never gets nulled out from under the user while they're typing.
      this.editRecipeObj.nutrition[recipeKey] = this.round2(totals[recipeKey]);
    });
  }

  // Rounds to a maximum of 2 decimal places; passes null/undefined/'' through
  // unchanged so visibility checks (`!= null`) elsewhere keep working.
  round2(value: any): any {
    if (value === null || value === undefined || value === '') {
      return value;
    }
    const num = Number(value);
    if (isNaN(num)) {
      return value;
    }
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }

  // Calories (kcal) = (Protein x 4) + (Carbs x 4) + (Fats x 9) + (Alcohol x 7)
  computeCalories(protein: any, carbs: any, fat: any, alcohol: any): number {
    const p = Number(protein) || 0;
    const c = Number(carbs) || 0;
    const f = Number(fat) || 0;
    const a = Number(alcohol) || 0;
    return this.round2((p * 4) + (c * 4) + (f * 9) + (a * 7));
  }

  onIngredientMacroChange(ingr: any) {
    if (ingr.nutrition) {
      ingr.nutrition.calories = this.computeCalories(
        ingr.nutrition.protein,
        ingr.nutrition.carbs,
        ingr.nutrition.fat,
        ingr.nutrition.alcoholGrams
      );
    }
    this.recalculateRecipeNutrition();
  }

  onMealMacroChange() {
    this.editRecipeObj.nutrition.calories = this.computeCalories(
      this.editRecipeObj.nutrition.protein,
      this.editRecipeObj.nutrition.carbs,
      this.editRecipeObj.nutrition.fats,
      this.editRecipeObj.nutrition.alcoholGrams
    );
  }

  deleteStore(index: any) {
    this.editRecipeObj.stores.splice
      (index, 1);
  }
  addStore() {
    this.editRecipeObj.stores.push({ storeName: '', location: '', website: '' });
  }
  deleteMethod(index: any) {
    this.editRecipeObj.cookingMethods.splice
      (index, 1);
  }
  addMethod() {
    this.editRecipeObj.cookingMethods.push({ method: '' });
  }

  editingMealId: any = null;
  editingMealDay: any = null;
  editMealType: string = '';
  editMealTimeValue: string = '';

  /** Convert "7:00 AM" / "7:00 PM" to 24h "HH:mm" for input type="time" */
  private timeTo24h(time12: string): string {
    if (!time12 || typeof time12 !== 'string') return '07:00';
    const t = time12.trim();
    const match = t.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
    if (!match) return '07:00';
    let h = parseInt(match[1], 10);
    const m = match[2];
    const period = (match[3] || '').toUpperCase();
    if (period === 'PM' && h !== 12) h += 12;
    if (period === 'AM' && h === 12) h = 0;
    const hh = h < 10 ? '0' + h : String(h);
    return hh + ':' + m;
  }

  /** Convert 24h "HH:mm" to "7:00 AM" for API */
  private timeFrom24h(time24: string): string {
    if (!time24 || typeof time24 !== 'string') return '7:00 AM';
    const [hh, mm] = time24.trim().split(':');
    let h = parseInt(hh, 10);
    const m = mm || '00';
    if (h === 12) return '12:' + m + ' PM';
    if (h === 0) return '12:' + m + ' AM';
    if (h > 12) return (h - 12) + ':' + m + ' PM';
    return h + ':' + m + ' AM';
  }

  openEditMealModal(meal: any, day: any) {
    this.editingMealId = meal.mealId;
    this.editingMealDay = day;
    this.editMealType = meal.mealType || meal.meal_type || '';
    this.editMealTimeValue = this.timeTo24h(meal.mealTime || meal.mealtime || '7:00 AM');
    $('#editMealModal').modal('show');
  }

  closeEditMealModal() {
    $('#editMealModal').modal('hide');
    this.editingMealId = null;
    this.editingMealDay = null;
    this.editMealType = '';
    this.editMealTimeValue = '';
  }

  showRecipeImageModal(src: string) {
    if (!src) {
      return;
    }
    const imgEl = document.getElementById('recipeModalImg');
    if (imgEl instanceof HTMLImageElement) {
      imgEl.src = src;
    }
    $('#recipeImageModal').modal('show');
  }

  closeRecipeImageModal() {
    $('#recipeImageModal').modal('hide');
  }

  getRecipeColClass(count: number): string {
    const maxPerRow = this.mode == 1 ? 2 : 3;
    const span = Math.floor(12 / maxPerRow);
    return `col-sm-${span} mt-1`;
  }

  saveMealFromModal() {
    if (!this.editMealType || !this.editMealTimeValue) {
      this.toast.errorMessage('Please select meal type and meal time.');
      return;
    }
    const mealId = this.editingMealId;
    const day = this.editingMealDay;
    const timeForApi = this.timeFrom24h(this.editMealTimeValue);
    const dayPlan = this.planDetails.find((plan: any) => plan.day === day);

    const currentMeal = dayPlan?.meals?.find((m: any) => m.mealId === mealId);
    if (currentMeal) {
      const currentType = currentMeal.mealType || currentMeal.meal_type || '';
      const currentTime = currentMeal.mealTime || currentMeal.mealtime || '';
      const currentTimeNorm = new Date('01/01/1992 ' + currentTime).getTime();
      const newTimeNorm = new Date('01/01/1992 ' + timeForApi).getTime();
      if (currentType === this.editMealType && currentTimeNorm === newTimeNorm) {
        this.toast.errorMessage('Meal type or meal time already there.');
        return;
      }
    }

    const selectedTime = new Date('01/01/1992 ' + timeForApi);

    if (dayPlan && dayPlan.meals && dayPlan.meals.length > 0) {
      const mealTypeAlreadyThere = dayPlan.meals.some((m: any) => {
        if (m.mealId === mealId) return false;
        const otherType = m.mealType || m.meal_type || '';
        return otherType === this.editMealType;
      });
      if (mealTypeAlreadyThere) {
        this.toast.errorMessage('Meal type is already there.');
        return;
      }

      const mealTimeAlreadyThere = dayPlan.meals.some((m: any) => {
        if (m.mealId === mealId) return false;
        const otherTime = new Date('01/01/1992 ' + (m.mealTime || m.mealtime)).getTime();
        return otherTime === selectedTime.getTime();
      });
      if (mealTimeAlreadyThere) {
        this.toast.errorMessage('Meal time is already there.');
        return;
      }
    }
    if (dayPlan && dayPlan.fastings && dayPlan.fastings.length > 0) {
      const fastingExists = dayPlan.fastings.some((f: any) => {
        const start = new Date('01/01/1992 ' + f.fromTime);
        const end = new Date('01/01/1992 ' + f.toTime);
        return selectedTime.getTime() >= start.getTime() && selectedTime.getTime() <= end.getTime();
      });
      if (fastingExists) {
        this.toast.errorMessage('A fasting window already exists at this time for this day.');
        return;
      }
    }

    const obj = {
      planId: this.id,
      mealId,
      type: this.editMealType,
      time: timeForApi,
      day
    };
    this.isLoading = 1;
    this.mealServiceV2.updateMealType(obj).subscribe(response => {
      if (response == 1) {
        this.toast.errorMessage('Some Exception Occurred. Please try again!');
        this.isLoading = 2;
      } else {
        const res: any = response;
        if (res.response === false) {
          this.toast.errorMessage('Details not updated or already exists. Please try again!');
          this.isLoading = 2;
        } else {
          this.toast.successMessage('Details Updated Successfully');
          this.closeEditMealModal();
          this.mealServiceV2.getMealPlanDetails(this.id, this.fromDate, this.toDate).subscribe(data => {
            this.isLoading = 2;
            if (data === 1) {
              this.error = 1;
              this.toast.errorMessage("Sorry, there was an error while processing your request. Please try again!");
            } else {
              this.error = 0;
              this.planDetails = data;
              this.mealPlanName = this.planDetails.mealPlanName;
              this.planDetails = this.planDetails.response;
            }
          });
        }
      }
    });
  }
}
